import { concatPath } from "./helpers";
import { setModuleLoaders, setModules } from "./modules";
import { App } from "./types";

/**
 * Current base app path
 *
 * @type {string}
 */
let currentBaseAppPath = "/";

// current app name
export let currentAppName: string;

/**
 * the list of apps
 *
 * @type {string}
 */
let allApps: App[] = [];

/**
 * List of all apps routes
 *
 * @type {string[]}
 */
export let appsList: string[] = [];

/**
 * Get current base app path
 */
export function getCurrentBaseAppPath(): string {
  return currentBaseAppPath;
}

/**
 * set current base app path
 */
export function setCurrentBaseAppPath(path: any): void {
  currentBaseAppPath = concatPath(path);

  currentAppName = allApps.find((app) => app.path === currentBaseAppPath)
    ?.name as string;
}

/**
 * Add new app path to the apps list
 *
 * @param {string} path
 */
export function addBaseAppPath(path: string): void {
  appsList.push(path);
}

export function getCurrentAppName(): string {
  return currentAppName;
}

/**
 * List modules from all applications
 *
 * @param {App[]} apps
 * @returns {void}
 */
export function setApps(apps: App[]): void {
  allApps = apps;

  for (const app of apps) {
    const { name, path, modules } = app;

    if (path) {
      addBaseAppPath(path);
    }

    for (const module of modules) {
      module.app = name;

      // module loaders
      setModuleLoaders(module);

      module.entry = (module.entry || []).map((route) =>
        concatPath(path, route)
      );

      // ser module list
      setModules(module);
    }
  }
}

/**
 * get the app path by the given app name
 *
 * @param {string} appName
 * @returns {string}
 */
export function getAppPath(appName: string): string {
  return allApps.find((app) => app.name === appName)?.path || "";
}
